<template>
  <v-dialog
    :value="showModalPaymentWithPix"
    @input="$emit('disagree')"
    max-width="600px"
    persistent
  >
    <v-card>
      <v-card-title>
        <span class="headline">Atualizar pendência paga via PIX</span>
      </v-card-title>
      <v-container grid-list-md>
        <v-flex sm12>
          <span class="subheading grey--text text--darken-2">
            Data do pagamento:
          </span>
          <div class="inputs pa-1 mt-1 mb-3">
            <datetime
              input-id="inputDate"
              type="datetime"
              value-zone="America/Sao_Paulo"
              zone="America/Sao_Paulo"
              v-model="paymentDate"
              :minute-step="1"
              required
            ></datetime>
          </div>
        </v-flex>
        <v-flex sm12>
          <span class="subheading grey--text text--darken-2">
            Observação:
          </span>
          <div>
            <v-text-field v-model="description" required></v-text-field>
          </div>
        </v-flex>
      </v-container>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="hideModal">Cancelar</v-btn>
        <v-btn
          color="green darken-1"
          :disabled="!description || !paymentDate"
          text
          @click="save"
          >Salvar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    showModalPaymentWithPix: Boolean,
    transactionId: Number,
  },
  data() {
    return {
      paymentDate: null,
      description: null,
    };
  },

  methods: {
    clearForm() {
      this.description = '';
      this.paymentDate = null;
    },

    hideModal() {
      this.$emit('disagree');
      this.clearForm();
    },

    save() {
      let data = {
        id: this.transactionId,
        description: this.description,
        capture_date: this.paymentDate,
      };
      this.$emit('agree', data);
      this.clearForm();
    },
  },
};
</script>
<style scoped>
.inputs {
  border-bottom: 1px solid grey;
  border-radius: 3px;
}

.inputs >>> #inputDate {
  width: 100%;
  text-align: center;
}
</style>
